import { render, staticRenderFns } from "./Tenants.vue?vue&type=template&id=14bb4f70&"
import script from "./Tenants.vue?vue&type=script&lang=ts&"
export * from "./Tenants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports